import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import DeleteItemCommand from './deleteItemCommand';

/**
 * Cut item command
 *
 * @class CutItemCommand
 * @extends DeleteItemCommand
 */
export default class CutItemCommand extends DeleteItemCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Cut ${this.items.length > 1 ? 'items' : this.items[0].attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.CutItemCommand = CutItemCommand;
